import T from "ramda/es/T";
import cond from "ramda/es/cond";
import isNil from "ramda/es/isNil";
import alwaysNull from "ramda-extension/es/alwaysNull";
import { CONTENT_TYPE, CONTENT_TYPE_HEADER_KEY } from '../../../../constants';
import { includeHeader, includeHeaderFile } from '../../../utils';
import { ARRAY_BUFFER_RESPONSE_TYPE } from '../../constants';
const arrayBufferToString = (arrayBuffer)=>{
    const uint8Array = new Uint8Array(arrayBuffer);
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(uint8Array);
};
export const parseXhrContent = (response)=>{
    const contentTypeHeader = response.xhr.getResponseHeader(CONTENT_TYPE_HEADER_KEY);
    return cond([
        [
            isNil,
            alwaysNull
        ],
        [
            includeHeader(CONTENT_TYPE.APPLICATION_JSON),
            ()=>JSON.parse(response.response instanceof ArrayBuffer ? arrayBufferToString(response.response) : response.response)
        ],
        [
            includeHeader('text'),
            ()=>response.response
        ],
        [
            includeHeaderFile,
            ()=>{
                if (response.responseType === ARRAY_BUFFER_RESPONSE_TYPE) {
                    return new Blob([
                        response.response
                    ], {
                        type: contentTypeHeader
                    });
                }
                return response.response;
            }
        ],
        [
            T,
            alwaysNull
        ]
    ])(contentTypeHeader);
};
